import { isBrowser } from '@landr/maestro';

var isInIframe = function isInIframe() {
  if (!isBrowser) {
    return false;
  }
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
var getEnvSuffix = function getEnvSuffix(environment) {
  switch (environment) {
    case 'development':
      return '-dev';
    case 'demo':
      return '-demo';
    case 'partner':
      return '-partner';
    case 'production':
    default:
      return '';
  }
};
var getApi3Endpoint = function getApi3Endpoint(environment) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  return "https://api3".concat(getEnvSuffix(environment), ".landr.com").concat(pathname);
};
var openLink = function openLink(link) {
  var forceSameWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!isBrowser) {
    return;
  }
  var currentHostname = window.location.hostname;
  var url = new URL(link);
  if (currentHostname === url.hostname) {
    // Same domain, keep the same tab
    window.history.pushState({}, '', link);
  } else {
    // open a new tab
    window.open(link, forceSameWindow && !isInIframe() ? '_self' : '_blank');
  }
};
var getWebAppLink = function getWebAppLink(env, pathname) {
  var currentHostname = isBrowser ? window.location.hostname : '';
  if (currentHostname.match(/^local.landr.com$/)) {
    return "https://local.landr.com:9102".concat(pathname);
  } else {
    return "https://app".concat(getEnvSuffix(env), ".landr.com").concat(pathname);
  }
};
var getGuestSiteLink = function getGuestSiteLink(env) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var domain;
  switch (env) {
    case 'development':
      domain = 'dev.landr.com';
      break;
    case 'demo':
      domain = 'demo.landr.com';
      break;
    case 'partner':
      domain = 'partner.landr.com';
      break;
    case 'production':
    default:
      domain = 'www.landr.com';
  }
  return "https://".concat(domain).concat(pathname);
};
var getSamplesLink = function getSamplesLink(env, pathname) {
  var currentHostname = isBrowser ? window.location.hostname : '';
  if (currentHostname.match(/^local.landr.com$/)) {
    return "https://local.landr.com:3000".concat(pathname);
  } else {
    return "https://samples".concat(getEnvSuffix(env), ".landr.com").concat(pathname);
  }
};

export { getApi3Endpoint, getEnvSuffix, getGuestSiteLink, getSamplesLink, getWebAppLink, isInIframe, openLink };
